const StandFirstTextblock = {
  getSettings: componentSettings => ({
    ...componentSettings,
    modifier: 'standfirst'
  })
};

export default StandFirstTextblock;
